import { useState, useEffect, useMemo } from 'react';
import { Link } from "react-router-dom";
import Sidebar from '../Sidebar'
import Header from '../Header'
import HeaderFilters from '../HeaderFilters';

import { GiPoliceOfficerHead } from "react-icons/gi";
import { MdCheck, MdLock, MdWhatsapp  } from "react-icons/md";

import { API_BASE } from '../../config/api';

import ReactApexChart from 'react-apexcharts';

function UsuariosSuperLider() {

  const [admin, setAdmin] = useState(null);
  const [loadingAdmin, setLoadingAdmin] = useState(true);

  useEffect(() => {
      const fetchAdmin = async () => {
          try {
              setLoadingAdmin(true);

              const res = await fetch(`${API_BASE}/api/admin/me`, {
                  method: "GET",
                  credentials: "include",
              });

              const data = await res.json();

              if (!res.ok || !data.ok) {
                  throw new Error(data.message || "No se pudo obtener la información del admin");
              }

              setAdmin(data.data);
          } catch (error) {
              console.error("Error al obtener admin:", error);
              setAdmin(null);
          } finally {
              setLoadingAdmin(false);
          }
      };

      fetchAdmin();
  }, []);

  // Panel General
    const [regions, setRegions] = useState([]);
    const [regionId, setRegionId] = useState("");

    const [distys, setDistys] = useState([]);
    const [grados, setGrados] = useState([]);

    const [distyId, setDistyId] = useState("");
    const [gradoId, setGradoId] = useState("");

    const [startDate, setStartDate] = useState("2026-05-11");
    const [endDate, setEndDate] = useState("2026-11-30");

    const [downloadingExcel, setDownloadingExcel] = useState(false);

    const [ascensosChart, setAscensosChart] = useState({
        categories: [],
        series: [],
        data: [],
    });

    const [summary, setSummary] = useState({
        usuariosRegistrados: 0,
        usuariosActivos: 0,
        usuariosNoActivos: 0,
        usuariosBorrados: 0,
        usuariosMexico: 0,
        usuariosLatam: 0,
        usuariosParticipantes: 0,
        usuariosNoParticipantes: 0,
    });

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const [datosUsuario, setDatosUsuario] = useState({
        totalUsuarios: 0,
        usuariosActivos: 0,
        usuariosParticipantes: 0,
        usuariosNoParticipantes: 0,
        tasaParticipacion: 0,
        tasaNoParticipacion: 0,
        tasaAscensoPorGrado: [],
    });

    const [loadingDatosUsuario, setLoadingDatosUsuario] = useState(false);
    const [filtersReady, setFiltersReady] = useState(false);

const handleRegionChange = async (value) => {
    setRegionId(value);
    setDistyId("");
    setGradoId("");

    await getFilters({
        nextRegionId: value,
        nextDistyId: "",
    });
};

const handleDistyChange = async (value) => {
    setDistyId(value);
    setGradoId("");

    await getFilters({
        nextRegionId: regionId,
        nextDistyId: value,
        updateRegions: false,
        updateDistys: false,
        updateGrados: true,
    });
};;

const handleGradoChange = (value) => {
    setGradoId(value);
};

    // =============================
    // Cargar filtros iniciales
    // =============================

const getFilters = async ({
    nextRegionId = "",
    nextDistyId = "",
    updateRegions = true,
    updateDistys = true,
    updateGrados = true,
} = {}) => {
    try {
        const params = new URLSearchParams();

        if (nextRegionId) params.append("regionId", nextRegionId);
        if (nextDistyId) params.append("distyId", nextDistyId);

        const response = await fetch(
            `${API_BASE}/api/admin/dashboard/filters?${params.toString()}`,
            {
                method: "GET",
                credentials: "include",
            }
        );

        const result = await response.json();

        if (!response.ok || !result.success) {
            throw new Error(result.message || "Error al obtener filtros.");
        }

        if (updateRegions) {
            setRegions(result.data?.regions || []);
        }

        if (updateDistys) {
            setDistys(result.data?.distys || []);
        }

        if (updateGrados) {
            setGrados(result.data?.grados || []);
        }

        return result.data;
    } catch (error) {
        console.error("Error filtros HomeSuperLider:", error);
        setError(error.message);
        return null;
    }
};

useEffect(() => {
    const initFilters = async () => {
        const data = await getFilters({
            updateRegions: true,
            updateDistys: true,
            updateGrados: true,
        });

        const defaultRegionId = String(data?.defaultRegionId || "");

        setRegionId(defaultRegionId);
        setDistyId("");
        setGradoId("");

        setStartDate(data?.defaultStartDate || "2026-05-11");
        setEndDate(data?.defaultEndDate || "2026-11-30");

        if (defaultRegionId) {
            await getFilters({
                nextRegionId: defaultRegionId,
                nextDistyId: "",
                updateRegions: false,
                updateDistys: true,
                updateGrados: true,
            });
        }

        setFiltersReady(true);
    };

    initFilters();
}, []);

// =============================
// Obtener datos de usuario - Super Líder
// =============================
const getDatosUsuarioSuperLider = async () => {
    try {
        setLoadingDatosUsuario(true);
        setError("");

        const params = new URLSearchParams();

        if (regionId) params.append("regionId", regionId);
        if (distyId) params.append("distyId", distyId);
        if (gradoId) params.append("gradoId", gradoId);
        if (startDate) params.append("startDate", startDate);
        if (endDate) params.append("endDate", endDate);

        const queryString = params.toString();

        const [
            datosUsuarioResponse,
            ascensosResponse,
        ] = await Promise.all([
            fetch(
                `${API_BASE}/api/admin/dashboard/superlider-datos-usuario?${queryString}`,
                {
                    method: "GET",
                    credentials: "include",
                }
            ),
            fetch(
                `${API_BASE}/api/admin/dashboard/ascensos-tasa-grado?${queryString}`,
                {
                    method: "GET",
                    credentials: "include",
                }
            ),
        ]);

        const datosUsuarioResult = await datosUsuarioResponse.json();
        const ascensosResult = await ascensosResponse.json();

        if (!datosUsuarioResponse.ok || !datosUsuarioResult.ok) {
            throw new Error(
                datosUsuarioResult.message || "Error al obtener datos de usuario."
            );
        }

        if (!ascensosResponse.ok || !ascensosResult.success) {
            throw new Error(
                ascensosResult.message || "Error al obtener tasa de ascenso por grado."
            );
        }

        setDatosUsuario({
            totalUsuarios: Number(datosUsuarioResult.data?.totalUsuarios || 0),
            usuariosActivos: Number(datosUsuarioResult.data?.usuariosActivos || 0),
            usuariosParticipantes: Number(datosUsuarioResult.data?.usuariosParticipantes || 0),
            usuariosNoParticipantes: Number(datosUsuarioResult.data?.usuariosNoParticipantes || 0),
            tasaParticipacion: Number(datosUsuarioResult.data?.tasaParticipacion || 0),
            tasaNoParticipacion: Number(datosUsuarioResult.data?.tasaNoParticipacion || 0),
            tasaAscensoPorGrado: Array.isArray(datosUsuarioResult.data?.tasaAscensoPorGrado)
                ? datosUsuarioResult.data.tasaAscensoPorGrado
                : [],
        });

        const ascensosData = ascensosResult.data || {};

        setAscensosChart({
            categories: Array.isArray(ascensosData.chart?.categories)
                ? ascensosData.chart.categories
                : [],

            series: Array.isArray(ascensosData.chart?.series)
                ? ascensosData.chart.series
                : [],

            data: Array.isArray(ascensosData.data)
                ? ascensosData.data
                : [],
        });
    } catch (error) {
        console.error("Error datos usuario Super Líder:", error);
        setError(error.message);

        setDatosUsuario({
            totalUsuarios: 0,
            usuariosActivos: 0,
            usuariosParticipantes: 0,
            usuariosNoParticipantes: 0,
            tasaParticipacion: 0,
            tasaNoParticipacion: 0,
            tasaAscensoPorGrado: [],
        });

        setAscensosChart({
            categories: [],
            series: [],
            data: [],
        });
    } finally {
        setLoadingDatosUsuario(false);
    }
};

// =============================
// Recargar datos cuando cambian filtros
// =============================
useEffect(() => {
    if (!filtersReady) return;

    getDatosUsuarioSuperLider();
}, [
    filtersReady,
    regionId,
    distyId,
    gradoId,
    startDate,
    endDate,
]);

const ascensosChartCategories = useMemo(() => {
    return Array.isArray(ascensosChart.categories)
        ? ascensosChart.categories
        : [];
}, [ascensosChart.categories]);

const ascensosChartSeries = useMemo(() => {
    return Array.isArray(ascensosChart.series)
        ? ascensosChart.series.map((serie) => ({
            name: serie.name || "Sin nombre",
            data: Array.isArray(serie.data) ? serie.data : [],
        }))
        : [];
}, [ascensosChart.series]);

const hasAscensosChartData =
    ascensosChartCategories.length > 0 &&
    ascensosChartSeries.length > 0;

const ascensosChartOptions = useMemo(() => {
    return {
        chart: {
            id: `ascensos-chart-${regionId || "all"}-${distyId || "all"}-${gradoId || "all"}`,
            type: "bar",
            stacked: true,
            stackType: "normal",
            toolbar: {
                show: true,
                tools: {
                    download: true,
                    selection: false,
                    zoom: false,
                    zoomin: false,
                    zoomout: false,
                    pan: false,
                    reset: false,
                },
            },
        },
        plotOptions: {
            bar: {
                horizontal: true,
                barHeight: "55%",
                borderRadius: 4,
                dataLabels: {
                    total: {
                        enabled: true,
                        offsetX: 8,
                        style: {
                            fontSize: "13px",
                            fontWeight: 600,
                        },
                    },
                },
            },
        },
        dataLabels: {
            enabled: true,
            formatter: function (value) {
                return Number(value || 0) > 0 ? value : "";
            },
            style: {
                fontSize: "12px",
                fontWeight: 600,
            },
        },
        stroke: {
            width: 1,
        },
        title: {
            text: "Embudo de avance por grado",
            align: "left",
        },
        subtitle: {
            text: "Distribución de usuarios activos por porcentaje de avance",
            align: "left",
        },
        xaxis: {
            categories: ascensosChartCategories,
            labels: {
                formatter: function (value) {
                    return Number(value || 0).toLocaleString("es-MX");
                },
            },
        },
        yaxis: {
            title: {
                text: undefined,
            },
        },
        tooltip: {
            shared: true,
            intersect: false,
            y: {
                formatter: function (value) {
                    return `${Number(value || 0).toLocaleString("es-MX")} usuarios`;
                },
            },
        },
        legend: {
            position: "top",
            horizontalAlign: "center",
        },
        fill: {
            opacity: 1,
        },
        noData: {
            text: "No hay información disponible para los filtros seleccionados.",
        },
    };
}, [
    ascensosChartCategories,
    regionId,
    distyId,
    gradoId,
]);


  return (
    <>
    <Sidebar/>
    <main class="main-content">
        <Header/>
        <div class="content-inner container-fluid pb-0" id="page_layout">
          <HeaderFilters
                title="Datos de Usuarios"
                subtitle="Panel Super Líder"

                regions={regions}
                distys={distys}
                grados={grados}

                regionId={regionId}
                distyId={distyId}
                gradoId={gradoId}

                startDate={startDate}
                endDate={endDate}

                onRegionChange={handleRegionChange}
                onDistyChange={handleDistyChange}
                onGradoChange={handleGradoChange}
                onStartDateChange={setStartDate}
                onEndDateChange={setEndDate}
            />
          
          <div className="row">
            <div className="col-lg-4">
                <div className="row">
                    <div class="col-lg-12 col-md-6">
                    <div class="card">
                        <div class="card-body">
                            <div class="d-flex justify-content-between align-items-center">
                                <div class="bg-info text-white rounded p-3">
                                <svg class="icon-20" width="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M11.9488 14.54C8.49884 14.54 5.58789 15.1038 5.58789 17.2795C5.58789 19.4562 8.51765 20.0001 11.9488 20.0001C15.3988 20.0001 18.3098 19.4364 18.3098 17.2606C18.3098 15.084 15.38 14.54 11.9488 14.54Z" fill="currentColor"></path>
                                    <path opacity="0.4" d="M11.949 12.467C14.2851 12.467 16.1583 10.5831 16.1583 8.23351C16.1583 5.88306 14.2851 4 11.949 4C9.61293 4 7.73975 5.88306 7.73975 8.23351C7.73975 10.5831 9.61293 12.467 11.949 12.467Z" fill="currentColor"></path>
                                    <path opacity="0.4" d="M21.0881 9.21923C21.6925 6.84176 19.9205 4.70654 17.664 4.70654C17.4187 4.70654 17.1841 4.73356 16.9549 4.77949C16.9244 4.78669 16.8904 4.802 16.8725 4.82902C16.8519 4.86324 16.8671 4.90917 16.8895 4.93889C17.5673 5.89528 17.9568 7.0597 17.9568 8.30967C17.9568 9.50741 17.5996 10.6241 16.9728 11.5508C16.9083 11.6462 16.9656 11.775 17.0793 11.7948C17.2369 11.8227 17.3981 11.8371 17.5629 11.8416C19.2059 11.8849 20.6807 10.8213 21.0881 9.21923Z" fill="currentColor"></path>
                                    <path d="M22.8094 14.817C22.5086 14.1722 21.7824 13.73 20.6783 13.513C20.1572 13.3851 18.747 13.205 17.4352 13.2293C17.4155 13.232 17.4048 13.2455 17.403 13.2545C17.4003 13.2671 17.4057 13.2887 17.4316 13.3022C18.0378 13.6039 20.3811 14.916 20.0865 17.6834C20.074 17.8032 20.1698 17.9068 20.2888 17.8888C20.8655 17.8059 22.3492 17.4853 22.8094 16.4866C23.0637 15.9589 23.0637 15.3456 22.8094 14.817Z" fill="currentColor"></path>
                                    <path opacity="0.4" d="M7.04459 4.77973C6.81626 4.7329 6.58077 4.70679 6.33543 4.70679C4.07901 4.70679 2.30701 6.84201 2.9123 9.21947C3.31882 10.8216 4.79355 11.8851 6.43661 11.8419C6.60136 11.8374 6.76343 11.8221 6.92013 11.7951C7.03384 11.7753 7.09115 11.6465 7.02668 11.551C6.3999 10.6234 6.04263 9.50765 6.04263 8.30991C6.04263 7.05904 6.43303 5.89462 7.11085 4.93913C7.13234 4.90941 7.14845 4.86348 7.12696 4.82926C7.10906 4.80135 7.07593 4.78694 7.04459 4.77973Z" fill="currentColor"></path>
                                    <path d="M3.32156 13.5127C2.21752 13.7297 1.49225 14.1719 1.19139 14.8167C0.936203 15.3453 0.936203 15.9586 1.19139 16.4872C1.65163 17.4851 3.13531 17.8066 3.71195 17.8885C3.83104 17.9065 3.92595 17.8038 3.91342 17.6832C3.61883 14.9167 5.9621 13.6046 6.56918 13.3029C6.59425 13.2885 6.59962 13.2677 6.59694 13.2542C6.59515 13.2452 6.5853 13.2317 6.5656 13.2299C5.25294 13.2047 3.84358 13.3848 3.32156 13.5127Z" fill="currentColor"></path>
                                </svg>
                                </div>
                                <div class="text-end">
                                Total de Usuarios
                                    <h2 class="counter" style={{visibility: 'visible'}}>
                                        {loadingDatosUsuario
                                        ? "..."
                                        : datosUsuario.totalUsuarios.toLocaleString("es-MX")}
                                    </h2>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="card">
                        <div class="card-body">
                            <div class="d-flex justify-content-between align-items-center">
                                <div class="bg-info text-white rounded p-3">
                                <svg class="icon-20" width="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M11.9488 14.54C8.49884 14.54 5.58789 15.1038 5.58789 17.2795C5.58789 19.4562 8.51765 20.0001 11.9488 20.0001C15.3988 20.0001 18.3098 19.4364 18.3098 17.2606C18.3098 15.084 15.38 14.54 11.9488 14.54Z" fill="currentColor"></path>
                                    <path opacity="0.4" d="M11.949 12.467C14.2851 12.467 16.1583 10.5831 16.1583 8.23351C16.1583 5.88306 14.2851 4 11.949 4C9.61293 4 7.73975 5.88306 7.73975 8.23351C7.73975 10.5831 9.61293 12.467 11.949 12.467Z" fill="currentColor"></path>
                                    <path opacity="0.4" d="M21.0881 9.21923C21.6925 6.84176 19.9205 4.70654 17.664 4.70654C17.4187 4.70654 17.1841 4.73356 16.9549 4.77949C16.9244 4.78669 16.8904 4.802 16.8725 4.82902C16.8519 4.86324 16.8671 4.90917 16.8895 4.93889C17.5673 5.89528 17.9568 7.0597 17.9568 8.30967C17.9568 9.50741 17.5996 10.6241 16.9728 11.5508C16.9083 11.6462 16.9656 11.775 17.0793 11.7948C17.2369 11.8227 17.3981 11.8371 17.5629 11.8416C19.2059 11.8849 20.6807 10.8213 21.0881 9.21923Z" fill="currentColor"></path>
                                    <path d="M22.8094 14.817C22.5086 14.1722 21.7824 13.73 20.6783 13.513C20.1572 13.3851 18.747 13.205 17.4352 13.2293C17.4155 13.232 17.4048 13.2455 17.403 13.2545C17.4003 13.2671 17.4057 13.2887 17.4316 13.3022C18.0378 13.6039 20.3811 14.916 20.0865 17.6834C20.074 17.8032 20.1698 17.9068 20.2888 17.8888C20.8655 17.8059 22.3492 17.4853 22.8094 16.4866C23.0637 15.9589 23.0637 15.3456 22.8094 14.817Z" fill="currentColor"></path>
                                    <path opacity="0.4" d="M7.04459 4.77973C6.81626 4.7329 6.58077 4.70679 6.33543 4.70679C4.07901 4.70679 2.30701 6.84201 2.9123 9.21947C3.31882 10.8216 4.79355 11.8851 6.43661 11.8419C6.60136 11.8374 6.76343 11.8221 6.92013 11.7951C7.03384 11.7753 7.09115 11.6465 7.02668 11.551C6.3999 10.6234 6.04263 9.50765 6.04263 8.30991C6.04263 7.05904 6.43303 5.89462 7.11085 4.93913C7.13234 4.90941 7.14845 4.86348 7.12696 4.82926C7.10906 4.80135 7.07593 4.78694 7.04459 4.77973Z" fill="currentColor"></path>
                                    <path d="M3.32156 13.5127C2.21752 13.7297 1.49225 14.1719 1.19139 14.8167C0.936203 15.3453 0.936203 15.9586 1.19139 16.4872C1.65163 17.4851 3.13531 17.8066 3.71195 17.8885C3.83104 17.9065 3.92595 17.8038 3.91342 17.6832C3.61883 14.9167 5.9621 13.6046 6.56918 13.3029C6.59425 13.2885 6.59962 13.2677 6.59694 13.2542C6.59515 13.2452 6.5853 13.2317 6.5656 13.2299C5.25294 13.2047 3.84358 13.3848 3.32156 13.5127Z" fill="currentColor"></path>
                                </svg>
                                </div>
                                <div class="text-end">
                                Usuarios Activos
                                    <h2 class="counter" style={{visibility: 'visible'}}>
                                        {loadingDatosUsuario
                                        ? "..."
                                        : datosUsuario.usuariosActivos.toLocaleString("es-MX")}
                                    </h2>
                                </div>
                            </div>
                        </div>
                    </div>
                    </div>

                    <div class="col-lg-12 col-md-6">
                        <div className="row">
                            <div className="col-lg-6">
                                <div class="card">
                                    <div class="card-body">
                                    <div class="d-flex flex-column align-items-between">
                                        <div>
                                            <div class="d-flex">
                                                <div class="bg-primary text-white p-3 rounded">
                                                <svg class="icon-24" width="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M11.9488 14.54C8.49884 14.54 5.58789 15.1038 5.58789 17.2795C5.58789 19.4562 8.51765 20.0001 11.9488 20.0001C15.3988 20.0001 18.3098 19.4364 18.3098 17.2606C18.3098 15.084 15.38 14.54 11.9488 14.54Z" fill="currentColor"></path>
                                                    <path opacity="0.4" d="M11.949 12.467C14.2851 12.467 16.1583 10.5831 16.1583 8.23351C16.1583 5.88306 14.2851 4 11.949 4C9.61293 4 7.73975 5.88306 7.73975 8.23351C7.73975 10.5831 9.61293 12.467 11.949 12.467Z" fill="currentColor"></path>
                                                    <path opacity="0.4" d="M21.0881 9.21923C21.6925 6.84176 19.9205 4.70654 17.664 4.70654C17.4187 4.70654 17.1841 4.73356 16.9549 4.77949C16.9244 4.78669 16.8904 4.802 16.8725 4.82902C16.8519 4.86324 16.8671 4.90917 16.8895 4.93889C17.5673 5.89528 17.9568 7.0597 17.9568 8.30967C17.9568 9.50741 17.5996 10.6241 16.9728 11.5508C16.9083 11.6462 16.9656 11.775 17.0793 11.7948C17.2369 11.8227 17.3981 11.8371 17.5629 11.8416C19.2059 11.8849 20.6807 10.8213 21.0881 9.21923Z" fill="currentColor"></path>
                                                    <path d="M22.8094 14.817C22.5086 14.1722 21.7824 13.73 20.6783 13.513C20.1572 13.3851 18.747 13.205 17.4352 13.2293C17.4155 13.232 17.4048 13.2455 17.403 13.2545C17.4003 13.2671 17.4057 13.2887 17.4316 13.3022C18.0378 13.6039 20.3811 14.916 20.0865 17.6834C20.074 17.8032 20.1698 17.9068 20.2888 17.8888C20.8655 17.8059 22.3492 17.4853 22.8094 16.4866C23.0637 15.9589 23.0637 15.3456 22.8094 14.817Z" fill="currentColor"></path>
                                                    <path opacity="0.4" d="M7.04459 4.77973C6.81626 4.7329 6.58077 4.70679 6.33543 4.70679C4.07901 4.70679 2.30701 6.84201 2.9123 9.21947C3.31882 10.8216 4.79355 11.8851 6.43661 11.8419C6.60136 11.8374 6.76343 11.8221 6.92013 11.7951C7.03384 11.7753 7.09115 11.6465 7.02668 11.551C6.3999 10.6234 6.04263 9.50765 6.04263 8.30991C6.04263 7.05904 6.43303 5.89462 7.11085 4.93913C7.13234 4.90941 7.14845 4.86348 7.12696 4.82926C7.10906 4.80135 7.07593 4.78694 7.04459 4.77973Z" fill="currentColor"></path>
                                                    <path d="M3.32156 13.5127C2.21752 13.7297 1.49225 14.1719 1.19139 14.8167C0.936203 15.3453 0.936203 15.9586 1.19139 16.4872C1.65163 17.4851 3.13531 17.8066 3.71195 17.8885C3.83104 17.9065 3.92595 17.8038 3.91342 17.6832C3.61883 14.9167 5.9621 13.6046 6.56918 13.3029C6.59425 13.2885 6.59962 13.2677 6.59694 13.2542C6.59515 13.2452 6.5853 13.2317 6.5656 13.2299C5.25294 13.2047 3.84358 13.3848 3.32156 13.5127Z" fill="currentColor"></path>
                                                </svg>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="mt-3">
                                            <span>Participantes</span>
                                            <div>
                                                <h3 class="counter" style={{visibility: 'visible'}}>
                                                {loadingDatosUsuario
                                                ? "..."
                                                : datosUsuario.usuariosParticipantes.toLocaleString("es-MX")}
                                                </h3>
                                            </div>
                                        </div>
                                        <div class="mt-3">
                                            <div class="badge bg-primary">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="20px" viewBox="0 0 20 20" fill="currentColor">
                                                <path fill-rule="evenodd" d="M5.293 9.707a1 1 0 010-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 01-1.414 1.414L11 7.414V15a1 1 0 11-2 0V7.414L6.707 9.707a1 1 0 01-1.414 0z" clip-rule="evenodd"></path>
                                                </svg>
                                                <span>
                                                {loadingDatosUsuario
                                                ? "..."
                                                : `${datosUsuario.tasaParticipacion}%`}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div class="card">
                                    <div class="card-body">
                                        <div class="d-flex flex-column align-items-between">
                                            <div>
                                            <div class="d-flex">
                                                <div class="bg-warning text-white p-3 rounded">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="25px" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z"></path>
                                                    </svg>
                                                </div>
                                            </div>
                                            </div>
                                            <div class="mt-3">
                                            <span>No participantes</span>
                                            <div>
                                                <h3 class="counter" style={{visibility: 'visible'}}>
                                                    {loadingDatosUsuario
                                                    ? "..."
                                                    : datosUsuario.usuariosNoParticipantes.toLocaleString("es-MX")}
                                                </h3>
                                            </div>
                                            </div>
                                            <div class="mt-3">
                                            <div class="badge bg-warning">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="20px" viewBox="0 0 20 20" fill="currentColor">
                                                    <path fill-rule="evenodd" d="M5.293 9.707a1 1 0 010-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 01-1.414 1.414L11 7.414V15a1 1 0 11-2 0V7.414L6.707 9.707a1 1 0 01-1.414 0z" clip-rule="evenodd"></path>
                                                </svg>
                                                <span>
                                                    {loadingDatosUsuario
                                                    ? "..."
                                                    : `${datosUsuario.tasaNoParticipacion}%`}
                                                </span>
                                            </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>

            <div className="col-lg-8">
                <div className="card">
                    <div className="card-header d-flex justify-content-between align-items-center">
                        <div>
                            <h5 className="mb-0">Tasa de ascenso por grado</h5>
                            <small className="text-muted">
                                Avance, elegibilidad y posibles embotellamientos.
                            </small>
                        </div>

                        {loadingDatosUsuario && (
                            <small className="text-muted">
                                Actualizando...
                            </small>
                        )}
                    </div>

                    <div className="card-body">
                        {loadingDatosUsuario ? (
                            <div className="py-5 text-center">
                                <div className="spinner-border text-primary" role="status">
                                    <span className="visually-hidden">Cargando...</span>
                                </div>

                                <p className="text-muted mt-3 mb-0">
                                    Cargando información de ascensos...
                                </p>
                            </div>
                        ) : !hasAscensosChartData ? (
                            <div className="py-5 text-center">
                                <p className="mb-0 text-muted">
                                    No hay información disponible para los filtros seleccionados.
                                </p>
                            </div>
                        ) : (
                            <>
                                <ReactApexChart
                                    key={`ascensos-chart-${regionId || "all"}-${distyId || "all"}-${gradoId || "all"}-${startDate}-${endDate}`}
                                    options={ascensosChartOptions}
                                    series={ascensosChartSeries}
                                    type="bar"
                                    height={360}
                                />

                                <div className="row g-3 mt-3">
                                    {ascensosChart.data.map((item) => (
                                        <div
                                            className="col-md-6"
                                            key={item.gradoId || item.gradoNombre}
                                        >
                                            <div className="border rounded p-3 h-100">
                                                <div className="d-flex justify-content-between align-items-start mb-2">
                                                    <div>
                                                        <h6 className="mb-1">
                                                            {item.gradoNombre}
                                                        </h6>

                                                        <small className="text-muted">
                                                            {Number(item.totalUsuarios || 0).toLocaleString("es-MX")} usuarios activos
                                                        </small>
                                                    </div>

                                                    <span className="badge bg-primary">
                                                        {Number(item.tasaAscenso || 0)}%
                                                    </span>
                                                </div>

                                                <div className="d-flex justify-content-between mt-3">
                                                    <div>
                                                        <small className="text-muted d-block">
                                                            Elegibles
                                                        </small>
                                                        <strong>
                                                            {Number(item.usuariosElegiblesAscenso || 0).toLocaleString("es-MX")}
                                                        </strong>
                                                    </div>

                                                    <div>
                                                        <small className="text-muted d-block">
                                                            Avance prom.
                                                        </small>
                                                        <strong>
                                                            {Number(item.avancePromedio || 0)}%
                                                        </strong>
                                                    </div>

                                                    <div>
                                                        <small className="text-muted d-block">
                                                            En progreso
                                                        </small>
                                                        <strong>
                                                            {Number(item.usuariosEnProgreso || 0).toLocaleString("es-MX")}
                                                        </strong>
                                                    </div>
                                                </div>

                                                <div className="mt-3 pt-3 border-top">
                                                    <div className="d-flex justify-content-between">
                                                        <small className="text-muted">
                                                            Atorados sesiones
                                                        </small>
                                                        <strong>
                                                            {Number(item.atoradosSesiones || 0).toLocaleString("es-MX")}
                                                        </strong>
                                                    </div>

                                                    <div className="d-flex justify-content-between">
                                                        <small className="text-muted">
                                                            Atorados evaluaciones
                                                        </small>
                                                        <strong>
                                                            {Number(item.atoradosEvaluaciones || 0).toLocaleString("es-MX")}
                                                        </strong>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </div>
          </div>

        </div>
    </main>
    </>
  )
}

export default UsuariosSuperLider